require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./biographie-de-martin-vetterli-0-1-0.json") })
        }
      }, "path---biographie-de-martin-vetterli-0-1-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---biographie-de-martin-vetterli-0-1-0!./.cache/json/biographie-de-martin-vetterli-0-1-0.json
// module id = 348
// module chunks = 231608221292675